module.exports = __webpack_public_path__ + "img/news_bg.af47ab4f.jpg";